import { ReactNode } from 'react';
import { Box, Paper, Skeleton, Typography } from '@mui/material';

interface DashboardStatsCardProps {
  title: string;
  icon: ReactNode;
  value: string;
}

export const DashboardStatsCard = (props: DashboardStatsCardProps) => {
  return (
    <Paper
      sx={{ display: 'flex', flexDirection: 'column', py: 3, px: 2, gap: 3 }}
    >
      <Typography variant='h6'>{props.title}</Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
        }}
      >
        {props.icon}

        <Box sx={{ flexGrow: 1 }} />

        <Typography variant='h5'>{props.value}</Typography>
      </Box>
    </Paper>
  );
};

export const DashboardStatsCardEmpty = () => (
  <Skeleton variant='rectangular' height={150} width='100%' />
);
